export const DeleteIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9999 4.99984L11.6054 10.8565C11.5057 12.252 10.3445 13.3332 8.94546 13.3332H7.05429C5.65525 13.3332 4.49408 12.252 4.3944 10.8565L3.99988 4.99984M2.66654 5.33317C2.66654 5.33317 4.44432 4.6665 7.99987 4.6665C11.5554 4.6665 13.3332 5.33317 13.3332 5.33317M10.6665 4.80457L10.6117 4.33771C10.451 3.37333 9.61663 2.6665 8.63895 2.6665H7.36079C6.38312 2.6665 5.54874 3.37333 5.38801 4.33771L5.33321 4.80457M9.66654 7.99984V9.99984M6.33321 7.99984V9.99984M7.99987 7.33317L7.99987 10.6665"
        stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}